enum CaseEvents {
  DocumentsValidationFailed = 'DocumentsValidationFailed',

  CasePageUpdateConflict = 'CasePageUpdateConflict',
  CaseEpisodeUpdateConflict = 'CaseEpisodeUpdateConflict',

  CaseTemplateOpened = 'CaseTemplateOpened',
  CaseTemplateCreated = 'CaseTemplateCreated',
  CaseTemplateUpdated = 'CaseTemplateUpdated',
  CaseTemplateUpdateConflict = 'CaseTemplateUpdateConflict',
  CaseTemplateDeleted = 'CaseTemplateDeleted',
  CaseTemplateImported = 'CaseTemplateImported',

  CaseWorkspaceSwitchToEpisodeView = 'CaseWorkspaceSwitchToEpisodeView',
  CaseWorkspaceSwitchToPagesView = 'CaseWorkspaceSwitchToPagesView',
  CaseWorkspaceSendToAIChat = 'CaseWorkspaceSendToAIChat',

  CaseDocumentFocusModeEnter = 'CaseDocumentFocusModeEnter',
  CaseWorkspaceFocusModeEnter = 'CaseWorkspaceFocusModeEnter',

  CaseEpisodesView = 'CaseEpisodesView',
  CaseAuditLogView = 'CaseAuditLogView',
  CaseWorkflowsView = 'CaseWorkflowsView',
  CaseTemplatesView = 'CaseTemplatesView',

  CaseDocumentsNavBarOpened = 'CaseDocumentsNavBarOpened',
  CaseDocumentsNavBarClosed = 'CaseDocumentsNavBarClosed',

  CasePagesBulkAction = 'CasePagesBulkAction',

  CasePagesSwitchToNewDesign = 'CasePagesSwitchToNewDesign',
  CasePagesSwitchToOldDesign = 'CasePagesSwitchToOldDesign',

  CaseReportPreviewOpened = 'CaseReportPreviewOpened',

  CaseDocumentCreated = 'CaseDocumentCreated',
  CaseDocumentDeleted = 'CaseDocumentDeleted',

  CaseFloatingSearchOpened = 'CaseFloatingSearchOpened'
};

export default CaseEvents;
